(() => {
  function init(root) {
    root.querySelectorAll('[data-matching-feature]').forEach(section => {
      if (section.dataset.matchingReady) return;
      const rail = section.querySelector('[data-matching-rail]');
      const controls = section.querySelector('[data-matching-controls]');
      const cards = [...rail.querySelectorAll('[data-matching-card]')];
      if (!cards.length || !controls) return;
      section.dataset.matchingReady = 'true';
      const prev = controls.querySelector('[data-matching-prev]');
      const next = controls.querySelector('[data-matching-next]');
      const status = controls.querySelector('[data-matching-position]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const positions = () => cards.map(card => card.getBoundingClientRect().left - rail.getBoundingClientRect().left + rail.scrollLeft);
      function update() {
        controls.hidden = rail.scrollWidth <= rail.clientWidth + 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
        const points = positions();
        const index = next.disabled ? cards.length - 1 : points.reduce((best,point,i) => Math.abs(point-rail.scrollLeft) < Math.abs(points[best]-rail.scrollLeft) ? i : best, 0);
        status.textContent = `${index + 1} / ${cards.length}`;
      }
      function move(direction) {
        const points = positions();
        const target = direction > 0 ? points.find(point => point > rail.scrollLeft + 3) : points.reverse().find(point => point < rail.scrollLeft - 3);
        rail.scrollTo({left: target ?? (direction > 0 ? rail.scrollWidth : 0), behavior: reduced.matches ? 'auto' : 'smooth'});
      }
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, {passive: true});
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      });
      new ResizeObserver(update).observe(rail);
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
